import { Base64 } from 'js-base64'

function base64Sign(endpoint) {
    let id = "21;";
    let url = process.env.REACT_APP_BASE_URL;
    let module = process.env.REACT_APP_SIGNATURE_STR;

    let sign = id+url+endpoint+module;
    let enc = Base64.encode(sign);
    // let dec = Base64.decode(enc);

    return enc;
}

export default base64Sign
